module.exports = __webpack_public_path__ + "img/LS-J-18.1676b048.svg";